import { CardWithHeader } from "@/components/card-with-header";
import { useCanSeeLabs } from "@/modules/labs/labs-visibility";
import { StablecoinsCard } from "@/modules/labs/stablecoins-card";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/_main-layout/_labs/labs")({
  component: () => <LabsPage />,
});

function LabsPage() {
  const canSeeLabs = useCanSeeLabs();

  if (!canSeeLabs) {
    return null;
  }

  return (
    <CardWithHeader
      variant="exchange"
      label="Labs"
      title="Experiments & beta products"
      fullHeight={false}
    >
      <p className="mb-6 text-sm text-slate-500">
        Early ideas we're exploring. Tell us what you'd use — your feedback
        shapes what we build next.
      </p>
      <StablecoinsCard />
    </CardWithHeader>
  );
}
